import React from 'react'
import "./FooterStyle.css"

const Footer = () => {
  return (
    <div>
        <p className='signature'> &copy; techlyCoded 2025</p>
    </div>
  )
}

export default Footer